import { queryOptions, useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { FundingApplicationSchemas } from "api-types";

import { DOCUMENT_UPLOADS_API } from "../../components/constants";

export const useDocumentQuery = (companySlug: string, applicationId: number) => {
  const options = useDocumentQueryOptions(companySlug, applicationId);
  return useQuery({
    ...options,
    refetchOnMount: "always",
  });
};

export const useDocumentQueryOptions = (companySlug: string, applicationId: number) => {
  const client = useAxios();

  const fetchUrl = DOCUMENT_UPLOADS_API.replace(":customerSlug", companySlug).replace(
    ":applicationId",
    applicationId.toString()
  );

  const queryFn = () => client.get<FundingApplicationSchemas.UploadedDocumentsSchema>(fetchUrl);

  return queryOptions({
    queryKey: [fetchUrl],
    queryFn,
    select: ({ data }): FundingApplicationSchemas.ListDocumentsResponse[] => data.documents,
  });
};
